import { singin, refreshToken } from "./login.service";

export const loginService = { singin, refreshToken };
